// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".al-spinner {\n  animation: al-spin 1s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes al-spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* El spinner es la unica senal de que algo pasa: se ralentiza, no se para. */\n@media (prefers-reduced-motion: reduce) {\n  .al-spinner { animation-duration: 2.4s; }\n}\n", ""]);
// Exports
module.exports = exports;
